import { render } from "./NotFound.vue?vue&type=template&id=08dcd884"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/errors/NotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08dcd884"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08dcd884', __exports__)) {
    console.log('reload')
    api.reload('08dcd884', __exports__)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=08dcd884", () => {
    console.log('re-render')
    api.rerender('08dcd884', render)
  })

}


export default __exports__